'use client'
import Link from "next/link";
import React, { useMemo } from "react";
import { Howl } from "howler";

let soundClick: Howl;
let soundHover: Howl;

if (typeof window !== undefined) {
    soundClick = new Howl({
        src: ["/assets/sfx/click.wav"],
        volume: 0.2,
    });

    soundHover = new Howl({
        src: ["/assets/sfx/hover.wav"],
        volume: 0.5,
    });
}


export enum ButtonStyle {
    Unstyled = 0,
    Primary,
    Active,
    Outline,
}

export default function Button({
    text,
    href,
    className,
    icon,
    onClick,
    style = ButtonStyle.Primary,
}: {
    text: string;
    href: string;
    className?: string;
    icon?: string;
    onClick?: () => any;
    style?: ButtonStyle;
}) {
    const onButtonPress = () => {
        if (onClick) onClick();
        soundClick.play();
    };

    const onButtonHover = () => {
        soundHover.rate(Math.floor(Math.random() * 0.5) + 2);
        soundHover.play();
    };

    if (onClick) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const href = null;
    }

    const classes = useMemo(() => {
        let temp =
            "select-none transition-all duration-75 ease-out py-1 px-4 rounded-md active:scale-90 a-unstyled ";
        temp += " " + (className ?? "");
        switch (style) {
            case ButtonStyle.Active:
                temp +=
                    " " +
                    "flex justify-center bg-ctp-mauve text-ctp-crust font-semibold";
                break;
            case ButtonStyle.Primary:
                temp +=
                    " " +
                    "flex justify-center bg-ctp-base hover:bg-ctp-surface1 text-white";
                break;
            case ButtonStyle.Outline:
                temp +=
                    " " +
                    "flex justify-center outline-1 outline-double outline-neutral-400 text-center text-white hover:bg-white hover:text-black bg-transparent";
        }
        return temp;
    }, [className, style]);

    return (
        <Link
            href={href}
            onClick={onButtonPress}
            onMouseOver={onButtonHover}
            onFocus={onButtonHover}
            className={classes}
        >
            {icon && <i className={icon + " pointer-events-none"}></i>}
            {text}
        </Link>
    );
}
